export const GalleriaStorage = [
    {
        imgURL:
        process.env.PUBLIC_URL + "/images/BookStore.jpg",
          imgAlt: "img-1"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/Calculator.jpg",
          imgAlt: "img-2"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/ColorPicker.jpg",
          imgAlt: "img-3"
      },
      {
        imgURL:
          process.env.PUBLIC_URL + "/images/CreditCard.jpg",
          imgAlt: "img-4"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/Fryzjer.jpg",
          imgAlt: "img-5"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/Gazeta.jpg",
          imgAlt: "img-6"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/Galleria.jpg",
          imgAlt: "img-7"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/LinkPage.jpg",
          imgAlt: "img-8"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/Omlette.jpg",
          imgAlt: "img-9"
      },
      {
        imgURL:
        process.env.PUBLIC_URL + "/images/ResponseWeb.jpg",
          imgAlt: "img-10"
      },
      


      
];
